import React, { Component } from 'react';
import Select from 'react-select';

class ReactSelect extends Component {
    constructor(props) {
        super();

        this.handleSelect = this.handleSelect.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            isDark: !!isDark,
        };
    }

    componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    handleSelect(data) {
        if (this.props.customeOnChange) return this.props.customeOnChange(data);
        this.props.onChange(data.value);
    }

    render() {
        const controlCustoStyles = this.props.controlStyles ?? {};
        const themeCustoStyles = this.props.themeStyles ?? {};
        const placeholderCustoStyles = this.props.placeholderStyles ?? {};
        const optionsCustomStyles = (state) =>
            this.props.optionsStyles ? this.props.optionsStyles(state) : {};
        return (
            <div className={`select-component ${this.props.classname ?? 'mx-15'}`}>
                {this.props.label && (
                    <label style={{ margin: '0 0 10px' }} className={this.props.labelClassname}>
                        {this.props.label}
                    </label>
                )}
                {!this.props.hideSelect && (
                    <Select
                        options={this.props.options}
                        defaultValue={this.props.defaultValue}
                        menuPortalTarget={document.querySelector('body')}
                        menuPosition={'fixed'}
                        onInputChange={this.props.onInputChange ?? (() => {})}
                        filterOption={this.props.customFilter ?? undefined}
                        styles={{
                            container: (baseStyles) => ({
                                ...baseStyles,
                                width: '100%',
                            }),
                            control: (baseStyles) => ({
                                ...baseStyles,
                                boxShadow: 'none',
                                padding: '1px 3px',
                                fontSize: '13px',
                                minWidth: '295px',
                                backgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                zIndex: 1,
                                ...controlCustoStyles,
                            }),
                            menuPortal: (provided) => ({
                                ...provided,
                                backgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                zIndex: 999999999,
                            }),
                            menu: (provided) => ({
                                ...provided,
                                backgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                color: this.state.isDark ? 'white' : 'black',
                                zIndex: 999999999,
                                overflow: 'hidden',
                            }),
                            option: (base, state) => ({
                                ...base,
                                color: state.isSelected
                                    ? 'white'
                                    : this.state.isDark
                                    ? 'white'
                                    : 'black',
                                backgroundColor: state.isSelected
                                    ? '#33b1a5'
                                    : state.isFocused
                                    ? this.state.isDark
                                        ? '#5c6375'
                                        : '#d0d5dd'
                                    : this.state.isDark
                                    ? '#2a3142'
                                    : 'white',
                                '&:hover': {
                                    backgroundColor: this.state.isDark ? '#5c6375' : '#d0d5dd',
                                    color: this.state.isDark ? 'white' : 'black',
                                },
                                '.default-selected': state.isSelected
                                    ? {
                                          borderColor: 'white',
                                          color: 'white',
                                      }
                                    : {
                                          borderColor: this.state.isDark ? '#5c6375' : '#33b1a5',
                                          color: this.state.isDark ? 'white' : '#33b1a5',
                                      },
                                '.project-domain-brand': {
                                    color: 'black',
                                },
                                ...optionsCustomStyles(state),
                            }),
                            multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: this.state.isDark
                                    ? '#101828'
                                    : provided.backgroundColor,
                                display: 'flex',
                            }),
                            placeholder: (base) => ({
                                ...base,
                                ...placeholderCustoStyles,
                            }),
                            indicatorSeparator: () => ({
                                display: 'none',
                            }),
                        }}
                        theme={(theme) => ({
                            ...theme,
                            height: '45px',
                            borderRadius: '7px',
                            borderColor: this.state.isDark ? '#1b1c28 ' : '#d9d9d9',
                            transition: 'all 0.2s',
                            backgroundColor: this.state.isDark ? '#2a3142 ' : 'white',
                            zIndex: 10,
                            colors: {
                                ...theme.colors,
                                primary: this.state.isDark ? 'white ' : '#33b1a5',
                            },
                            ...themeCustoStyles,
                        })}
                        onChange={this.props.isMulti ? this.props.onChange : this.handleSelect}
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        isSearchable={this.props.isSearchable}
                        onFocus={(e) => {
                            if (this.props.isSearchable) {
                                const parent = e.nativeEvent.target.parentNode.parentNode;
                                const selectedValue = parent.children[0];
                                selectedValue.style.display = 'none';
                            }

                            this.props.onFocus && this.props.onFocus();
                        }}
                        onBlur={(e) => {
                            if (this.props.isSearchable) {
                                const parent = e.nativeEvent.target.parentNode.parentNode;
                                const selectedValue = parent.children[0];
                                selectedValue.style.display = 'inline-grid';
                            }

                            this.props.onBlur && this.props.onBlur();
                        }}
                        blurInputOnSelect={this.props.blurInputOnSelect}
                        isMulti={this.props.isMulti}
                        isDisabled={this.props.disabled}
                        components={this.props.components ?? {}}
                    />
                )}
            </div>
        );
    }
}

export default ReactSelect;
